/**
 * Karexia brand mark (web) — an abstract roof/home "K" (two ascending pitches)
 * wrapped by a warm-gold orbit with an AI spark, on the app's indigo→violet
 * badge. Mirrors the mobile BrandMark, tuned to the web theme. Self-contained
 * SVG (own gradients), so it also backs the favicon.
 */
export function BrandLogo({
  className,
  title = 'Karexia',
}: {
  className?: string;
  title?: string;
}) {
  return (
    <svg
      viewBox="0 0 100 100"
      className={className}
      role="img"
      aria-label={title}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="kx_badge" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#6366F1" />
          <stop offset="0.55" stopColor="#4F46E5" />
          <stop offset="1" stopColor="#7C3AED" />
        </linearGradient>
        <linearGradient id="kx_gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F6C667" />
          <stop offset="1" stopColor="#E8A838" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="96" height="96" rx="26" fill="url(#kx_badge)" />
      <g>
        <path d="M28 66 L28 50 L44 36 L44 52 Z" fill="#fff" opacity="0.95" />
        <path d="M46 66 L46 44 L64 28 L72 35 L72 66 Z" fill="#fff" />
        <rect x="55" y="52" width="9" height="14" rx="2.4" fill="#4F46E5" opacity="0.9" />
      </g>
      <path d="M22 40 A32 32 0 1 0 78 34" stroke="url(#kx_gold)" strokeWidth="5.5" strokeLinecap="round" fill="none" />
      <circle cx="78" cy="34" r="5.6" fill="url(#kx_gold)" />
      <circle cx="78" cy="34" r="2.2" fill="#fff" />
    </svg>
  );
}

export default BrandLogo;
